import React from 'react';
import GenericDialog from '@common/GenericDialog';
import {TestSkillSummary} from "./Assessments/components/SkillSummaryView";

const TestSkillSummaryDialog = ({
                               open,
                               onClose,
                               testId,
                               title,
                               searchAndAdd
                           }) => {


    return (
        <GenericDialog
            title={title}
            open={open}
            fullWidth={true}
            onClose={onClose}
            buttons={[
                { name: 'Close' },
            ]}
        >
            <TestSkillSummary searchAndAdd={searchAndAdd} testId={testId}/>
        </GenericDialog>
    );
};

export default TestSkillSummaryDialog;
